import { render, staticRenderFns } from "./Alpha.vue?vue&type=template&id=6e03074e&"
import script from "./Alpha.vue?vue&type=script&lang=js&"
export * from "./Alpha.vue?vue&type=script&lang=js&"
import style0 from "./Alpha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/tine20/Tinebase/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e03074e')) {
      api.createRecord('6e03074e', component.options)
    } else {
      api.reload('6e03074e', component.options)
    }
    module.hot.accept("./Alpha.vue?vue&type=template&id=6e03074e&", function () {
      api.rerender('6e03074e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@caohenghu/vue-colorpicker/src/color/Alpha.vue"
export default component.exports